module.exports = __webpack_public_path__ + "img/ic-download-invoice.1f3c1b55.svg";